<!-- 首页路由 -->
<template>
    <div class="index">
        <!-- 顶部标题 -->
        <div class="index-nav-bar">
            <van-nav-bar title="郑州华夏白癜风医院" />
        </div>

        <!-- 内容区 -->
        <Headernav />

        <!-- 咨询菜单 -->
        <div class="index-consult">
            <div class="index-consult">
                <div class="index-consult-title">
                    <div class="index-consult-title-item">
                        <img src="@/assets/icon/shijian.png" alt="" srcset="">
                        <span>响应及时</span>
                    </div>
                    <div class="index-consult-title-item">真实医生</div>
                    <div class="index-consult-title-item">不接诊随时退</div>
                </div>
                <ul class="index-consult-list">
                    <li class="index-consult-list-item" v-for="item in consultList" :key="item.id">
                        <div class="consult-list-item-left">
                            <img class="consult-list-itemleft-icon" :src="item.icon" alt="">
                            <div class="consult-list-itemleft-div">
                                <h1>{{ item.title }}</h1>
                                <span v-html="item.text"></span>
                            </div>
                        </div>
                        <div class="consult-list-item-right" @click="showPopu">
                            去问诊
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <!-- 医生推荐 -->
        <div class="index-doctor">

            <div class="index-doctor-header">
                <h1>医生团队</h1>
                <div class="index-doctor-header-gengduo" @click="GoDoctor">
                    <span>更多</span>
                    <img src="@/assets/icon/gengduo.png" alt="" srcset="">
                </div>
            </div>

            <ul class="index-doctor-list">
                <li class="index-doctor-item" v-for="item in doctorList" :key="item.id"
                    @click="GoDeatile(item.id, 'doctot')">
                    <div class="index-doctor-item-avative">
                        <img :src="baseUrl + item.docavatar" alt="" srcset="">
                        <span>精选</span>
                    </div>
                    <div class="index-doctor-item-xinxi">
                        <div class="doctor-item-xinxi-box">
                            <ul class="doctor-item-xinxi-left">
                                <li class="item-xinxi-left-Item1">
                                    <span class="span-item1">{{ item.docname }}</span>
                                    <!-- <span class="span-item2">副主任医师</span>
                                    <span class="span-item3">白癜风科</span> -->
                                </li>
                                <li class="item-xinxi-left-Item3">郑州华夏白癜风医院</li>
                            </ul>
                            <div class="doctor-item-xinxi-right">
                                <span>明日有号</span>
                                <div @click.stop="showPopu">
                                    去预约
                                </div>
                            </div>
                        </div>
                        <div class="doctor-item-xinxi-button font_hiddles">
                            摘要：{{ item.synopsis }}
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <!-- 热点关注 -->
        <div class="index-answers">

            <div class="index-doctor-header">
                <h1>热点关注</h1>
                <div class="index-doctor-header-gengduo" @click="Gofollow">
                    <span>更多</span>
                    <img src="@/assets/icon/gengduo.png" alt="" srcset="">
                </div>
            </div>

            <ul class="index-answers-title">
                <li class="haedernav-header-font-item">
                    <span class="font-item-span1">服务次数</span>
                    <span class="font-item-span2">4844</span>
                </li>
                <li class="haedernav-header-font-item">
                    <span class="font-item-span1">好评数</span>
                    <span class="font-item-span2">4844</span>
                </li>
                <li class="haedernav-header-font-item">
                    <span class="font-item-span1">好评率</span>
                    <span class="font-item-span2">50%</span>
                </li>
            </ul>

            <ul class="index-answers-content">
                <li class="index-answers-content-item" v-for="item in hotlistList" :key="item.id"
                    @click="GoDeatile(item.id, 'article')">
                    <div class="answers-content-item-title">
                        <span>问</span>
                        {{ item.mesname }}
                    </div>
                    <div class="answers-content-item-text">
                        <span>答</span>
                        {{ item.messynops }}【更多】
                    </div>
                </li>
            </ul>
        </div>

        <!-- 医院信息 -->
        <HosDetaile />

        <!-- 消息按钮 -->
        <Consultation @closePopu="closePopu" />

        <!-- 通讯咨询 -->
        <Messagecom ref="RefMessagecom" />

        <!-- 底部菜单 -->
        <FootMeun @closePopu="closePopu" />
    </div>
</template>

<script>
import { getindexdataApi } from "@/api/resourceApi"
import config from "@/utils/config";
import Headernav from '@/components/Headernav.vue';
import FootMeun from '@/components/FootMeun.vue';
import HosDetaile from '@/components/HosDetaile.vue';
import Consultation from '@/components/Consultation.vue';
import Messagecom from '@/components/Messagecom.vue';
export default {
    data() {
        return {
            consultList: [
                {
                    id: 1,
                    title: "图文问诊",
                    icon: require("@/assets/icon/yisheng.png"),
                    text: "<font color='#FF6F61'>24小时</font>不限次交流，足不出户问名医",
                },
                {
                    id: 2,
                    title: "电话问诊",
                    icon: require("@/assets/icon/dianhua.png"),
                    text: "连线医生，沟通病情<font color='#FF6F61'>更清晰更高效</font>",
                },
                {
                    id: 3,
                    title: "视频问诊",
                    icon: require("@/assets/icon/shipin.png"),
                    text: "医生解答，<font color='#FF6F61'>面对面问诊</font>更亲切更直观 ",
                },
                {
                    id: 4,
                    title: "预约问诊",
                    icon: require("@/assets/icon/yuyue.png"),
                    text: "涵盖医生<font color='#FF6F61'>全网号源</font>，线下面诊更安心 ",
                }
            ],
            baseUrl: config.baseUrl,
            doctorList: [],
            hotlistList: []
        }
    },
    components: {
        Headernav,
        FootMeun,
        HosDetaile,
        Consultation,
        Messagecom
    },
    created() {
        this.getindexdataApiRequest()
    },
    methods: {
        async getindexdataApiRequest() {
            let resout = await getindexdataApi()
            this.doctorList = resout.data.doctorlist
            this.hotlistList = resout.data.hotlist
        },
         closePopu(valuer) {
            location.href = "https://c-24004.p.easyliao.com/live/chat.do?c=24004&g=10107287&config=31591&ref=youhua"
            // this.$refs.RefMessagecom.Showpopup(valuer)
        },
        showPopu() {
            location.href = "https://c-24004.p.easyliao.com/live/chat.do?c=24004&g=10107287&config=31591&ref=youhua"
            // this.$refs.RefMessagecom.Showpopup(true)
        },
        GoDoctor() {
            this.$router.push("/doctor")
        },
        Gofollow() {
            this.$router.push("/follow")
        },
        GoDeatile(id, type) {
            this.$router.push({
                path: "/detaile",
                query: {
                    id: id,
                    type: type
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.index {
    width: 100%;
    min-height: 100%;
    padding-bottom: 66px;
    padding-top: 45px;
    box-sizing: border-box;

    //热门问答
    .index-answers {
        width: 100%;
        padding: 5px 20px;
        box-sizing: border-box;

        .index-answers-content {
            margin-top: 15px;
            width: 100%;

            .index-answers-content-item {
                width: 100%;
                padding: 10px 0;
                border-bottom: 1px solid #d9d9d9;

                .answers-content-item-text {
                    font-size: 12px;
                    color: #404040;
                    margin-top: 10px;
                    line-height: 1.5;
                    text-align: justify;

                    span {
                        display: inline-block;
                        padding: 1px 2px;
                        margin-right: 10px;
                        font-size: 13px;
                        color: #4e85e2;
                        border: solid 1px #4e85e2;
                        border-radius: 2px;
                        line-height: 1;
                    }
                }

                .answers-content-item-title {
                    font-size: 14px;
                    font-weight: bold;
                    color: #404040;

                    span {
                        display: inline-block;
                        padding: 1px 2px;
                        margin-right: 10px;
                        font-size: 13px;
                        color: #f19149;
                        border: solid 1px #f19149;
                        border-radius: 2px;
                    }
                }
            }

        }

        .index-answers-title {
            display: flex;
            align-items: center;
            margin: 10px 0;

            .haedernav-header-font-item {
                font-size: 11px;
                font-weight: 500;
                margin-right: 15px;

                .font-item-span1 {
                    color: #888;
                }

                .font-item-span2 {
                    color: #FD503E;
                    margin-left: 3px;
                }
            }
        }

        .index-doctor-header {
            display: flex;
            justify-content: space-between;

            h1 {
                font-size: 20px;
                color: #000;
            }

            .index-doctor-header-gengduo {
                display: flex;
                align-items: center;

                span {
                    font-size: 13px;
                    color: #666;
                }

                img {
                    width: 15px;
                    height: 15px;
                    margin-left: 3px;
                }
            }
        }
    }

    //医生列表
    .index-doctor {
        width: 100%;
        padding: 5px 20px;
        box-sizing: border-box;

        .index-doctor-list {
            width: 100%;
            height: auto;
            background-color: #F8F8F8;
            border-radius: 10px;
            padding: 20px 10px;
            box-sizing: border-box;
            margin-top: 15px;

            .index-doctor-item:last-of-type {
                margin-bottom: 0px !important;
            }

            .index-doctor-item {
                width: 100%;
                display: flex;
                justify-content: space-between;
                margin-bottom: 20px;

                .index-doctor-item-xinxi {
                    margin-left: 10px;
                    flex: 1;

                    .doctor-item-xinxi-box {
                        display: flex;
                        justify-content: space-between;

                        .doctor-item-xinxi-right {
                            display: flex;
                            flex-direction: column;

                            span {
                                width: 55px;
                                text-align: center;
                                font-size: 9px;
                                color: #FD503E;
                            }

                            div {
                                width: 55px;
                                height: 27px;
                                border-radius: 27px;
                                background-color: #00c8c8;
                                text-align: center;
                                line-height: 30px;
                                color: #fff;
                                font-size: 12px;
                                margin-top: 5px;
                            }
                        }

                        .doctor-item-xinxi-left {
                            flex: 1;
                            display: flex;
                            flex-direction: column;

                            .item-xinxi-left-Item3 {
                                font-size: 10px;
                                color: #7D7F8B;
                                margin-top: 4px;
                            }

                            .item-xinxi-left-Item2 {
                                font-size: 12px;
                                color: #333;
                                margin-top: 2px;
                            }

                            .item-xinxi-left-Item1 {
                                display: flex;
                                align-items: center;

                                .span-item1 {
                                    font-size: 15px;
                                    font-weight: bold;
                                    color: #1F1F1F;
                                }

                                .span-item2 {
                                    font-size: 10px;
                                    color: #666;
                                    margin-left: 5px;
                                }

                                .span-item3 {
                                    font-size: 10px;
                                    color: #666;
                                    margin-left: 5px;
                                }
                            }
                        }
                    }

                    .doctor-item-xinxi-button {
                        width: 100%;
                        -webkit-line-clamp: 3;
                        font-size: 12px;
                        color: #333;
                        margin-top: 5px;
                    }
                }

                .index-doctor-item-avative {
                    width: 60px;
                    height: 60px;
                    position: relative;

                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        border: 1px solid #bbb;
                    }

                    span {
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        background-color: #FF6500;
                        padding: 2px 3px;
                        border-radius: 10px;
                        font-size: 9px;
                        color: #fff;
                    }
                }
            }
        }

        .index-doctor-header {
            display: flex;
            justify-content: space-between;

            h1 {
                font-size: 20px;
                color: #000;
            }

            .index-doctor-header-gengduo {
                display: flex;
                align-items: center;

                span {
                    font-size: 13px;
                    color: #666;
                }

                img {
                    width: 15px;
                    height: 15px;
                    margin-left: 3px;
                }
            }
        }
    }

    //咨询菜单
    .index-consult {
        width: 100%;
        padding: 5px 10px;
        box-sizing: border-box;

        .index-consult-list {
            width: 100%;

            .index-consult-list-item {
                margin: 15px 0;
                height: 66px;
                background: #fff;
                box-shadow: 0 2px 8px rgb(0, 0, 0, .1);
                border-radius: 8px;
                padding: 0 18px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .consult-list-item-left {
                    flex: 1;
                    display: flex;

                    .consult-list-itemleft-icon {
                        width: 33px;
                        height: 33px;
                    }

                    .consult-list-itemleft-div {
                        margin-left: 10px;
                        display: flex;
                        flex-direction: column;

                        h1 {
                            font-size: 18px;
                            color: #000;
                        }

                        span {
                            margin-top: 5px;
                            font-size: 8px;
                            color: #999;
                        }
                    }
                }

                .consult-list-item-right {
                    margin-left: 20px;
                    width: 80px;
                    height: 30px;
                    font-size: 12px;
                    color: #fff;
                    line-height: 30px;
                    background: #00c8c8;
                    border-radius: 15px;
                    text-align: center;
                }
            }
        }

        .index-consult-title {
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;

            .index-consult-title-item {
                display: flex;
                align-items: center;
                font-size: 12px;
                color: #333;

                img {
                    width: 13px;
                    height: 13px;
                    margin-right: 5px;
                }
            }
        }
    }
}
</style>